import TeamsBody from "../features/teams/index"

const TeamPage = () => {
    return (
        <>
            <TeamsBody />
        </>
    )
}

export default TeamPage